// matches the list of breakpoints from the shared breakpoints.scss
export const breakpoints = {
  xxs: 360,
  xs: 480,
  sm: 640,
  md: 768,
  lg: 820,
  xl: 1170,
};

// sample sizes between breakpoints for use in testing
export const testBreakpoints = {
  mobileXS: 320,
  mobile: 400,
  tabletXS: 600,
  tablet: 760,
  desktopXS: 800,
  desktop: 1000,
  desktopXL: 1200,
};
